type CloudApiClient<T> = {
  get: (path: '/api/tenants') => Promise<readonly T[]>;
};

type TenantApiClient<T> = {
  list: () => Promise<readonly T[]>;
};

type Input<T> = {
  isCloud: boolean;
  isMultiTenant: boolean;
  cloudApi: CloudApiClient<T>;
  tenantApi: TenantApiClient<T>;
  resetTenants: (tenants: readonly T[]) => void;
};

/**
 * Pure side-effectful loader shared by `ProtectedRoutes` and its tests.
 *
 * - In Cloud we fetch tenants from the Cloud service.
 * - In self-hosted multi-tenant we fetch from the local admin-tenant `/api/tenants` endpoint.
 * - In single-tenant OSS there's nothing to load — `resetTenants` is skipped because the
 *   initial list already contains the default tenant.
 */
export const loadTenantsForProvider = async <T>({
  isCloud,
  isMultiTenant,
  cloudApi,
  tenantApi,
  resetTenants,
}: Input<T>): Promise<void> => {
  if (isCloud) {
    const data = await cloudApi.get('/api/tenants');
    resetTenants(data);
    return;
  }
  if (isMultiTenant) {
    const data = await tenantApi.list();
    resetTenants(data);
  }
};
